export default (urlParameters) => {
  return {
    ads_allowed: true,
    footer_ad: true,
    nc_wind_toggle_allowed: false,
    storm_center: true,
    storm_track: true
  }
}